export const pushSubscriptionDeviceName = (subscription) => 'deviceName' in subscription ? subscription.deviceName : undefined;
/** Identity used to send a push. Duplicate keys mean duplicate notifications. */
export const pushSubscriptionDeliveryKey = (subscription) => {
    switch (subscription.type) {
        case 'web':
            return `web:${subscription.endpoint}`;
        case 'webhook':
            return `webhook:${subscription.url}`;
        case 'apn':
            return `apn:${subscription.apnToken}`;
        case 'fcm':
            return `fcm:${subscription.fcmToken}`;
    }
};
export const pushSubscriptionEndpoint = (subscription) => 'endpoint' in subscription ? subscription.endpoint : undefined;
export const pushSubscriptionIsMobile = (subscription) => pushSubscriptionDeviceName(subscription)
    ?.toLowerCase()
    .match(/phone|android|mobile|ios/) != null;
